/* © CNES */
import React from 'react';

interface State {
  name?: string;
}

interface Region {
  name?: string;
  states?: State[];
}

interface Country {
  name?: string;
  regions?: Region[];
}

interface Continent {
  name?: string;
  countries?: Country[];
}

interface LocationData {
  continents?: Continent[];
}

interface LocationTreeProps {
  locationData?: LocationData;
}

/**
 * LocationTree Component
 *
 * This component displays a hierarchical view of continents, countries, regions, and states.
 *
 *
 * @param {LocationTreeProps} props - The props containing the location data.
 * @returns {JSX.Element} The rendered component displaying the location hierarchy.
 */
export const LocationTree: React.FC<LocationTreeProps> = ({ locationData }) => {
  if (!locationData) {
    return null;
  }

  return (
    <div className="LocationContainer">
      {locationData?.continents?.map((continent, index) => (
        <div key={continent?.name! + index}>
          <p className="LocationName" style={{ marginLeft: '0em' }}>
            {continent?.name}
          </p>

          {continent?.countries?.map((country, index) => (
            <div key={country?.name! + index}>
              <p className="LocationName" style={{ marginLeft: '2em' }}>
                {country?.name}
              </p>

              {country?.regions?.map((region, index) => (
                <div key={region?.name! + index}>
                  <p
                    className="LocationName"
                    style={{ marginLeft: '4em', display: 'flex' }}
                  >
                    {region?.name} :
                    {region?.states?.map((state, index) => (
                      <span
                        key={state?.name! + index}
                        style={{ marginLeft: '2px' }}
                      >
                        {state?.name}
                      </span>
                    ))}
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
